import { ComponentFactoryResolver, Injectable, ViewContainerRef } from '@angular/core';
import { IConfigAccelerator } from '@core/models/accelerator';

@Injectable()
export class MdToastService {
  public rootViewContainer: ViewContainerRef;
  private controllerInstance: any;

  constructor(public factoryResolver: ComponentFactoryResolver) {}

  public setRootViewContainerRef(viewContainerRef: ViewContainerRef) {
    this.rootViewContainer = viewContainerRef;
  }

  public show(component, config: IConfigAccelerator) {
    const factory = this.factoryResolver.resolveComponentFactory(component);
    this.controllerInstance = factory.create(this.rootViewContainer.injector);
    let componentData = { ...config.data };
    if (config.hideDelay) {
      componentData = { ...componentData, hideDelay: config.hideDelay };
    }
    this.controllerInstance.instance = Object.assign(
      this.controllerInstance.instance,
      componentData,
    );
    this.rootViewContainer.insert(this.controllerInstance.hostView);
  }
}
